import { BooleanInput } from '@angular/cdk/coercion';
import {
  Component,
  ViewEncapsulation,
  booleanAttribute,
  contentChildren,
  input,
  output,
  signal,
} from '@angular/core';
import { FormRowDirective } from '../../directives/form-row.directive';
import { Button } from '../button/button.component';
import { ExpansionPanel } from '../expansion-panel/expansion-panel.component';
import { FilterItem } from '../filter-item/filter-item.component';

@Component({
  selector: 'procure-filter-grid',
  templateUrl: './filter-grid.component.html',
  styleUrl: './filter-grid.component.scss',
  imports: [Button, FormRowDirective, ExpansionPanel],
  // ViewEncapsulation needs to be disabled in order to style the projected content
  encapsulation: ViewEncapsulation.None,
})
export class FilterGrid {
  readonly filterButtons = contentChildren(FilterItem);

  readonly label = input<string>('Filters');

  readonly vertical = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly showAll = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly loading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly defaultExpanded = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly activeFilters = input<number>(0);

  readonly resetFilters = output<void>();
  readonly opened = output<void>();

  protected readonly expanded = signal(false);

  protected toggleExpansion(): void {
    this.expanded.update((expanded) => !expanded);
  }
}
